webpackJsonp([7],{

/***/ 108:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_steem__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_steem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_steem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_remarkable__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_remarkable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_remarkable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_infinite_scroll__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_infinite_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_infinite_scroll__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

 // 스팀잇 라이브러리 임포트


// import { mapState, mapGetters } from 'vuex'

var md = new __WEBPACK_IMPORTED_MODULE_1_remarkable___default.a({ html: true, linkify: true });

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      discussions: [],
      busy: false,
      next: {
        exist: true,
        permlink: null,
        author: null
      }
    };
  },
  computed: {
    // isLogin () {
    //   return this.$store.getters['auth/isLogin']
    // },
    // ...mapGetters('auth', [ 'isLogin' ]),
    // ...mapState('auth', [ 'username' ]),
    UserProfilePanel: function UserProfilePanel() {
      // console.log('isLogin:', this.$store.getters['auth/isLogin'])
      // if (this.isLogin) {
      if (this.$store.getters['auth/isLogin']) {
        return function () {
          return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 670));
        };
      } else {
        return function () {
          return '';
        };
      }
    },
    type: function type() {
      return this.$route;
    }
  },
  // components: {
  //   UserProfilePanel: () => {
  //     console.log('this.isLogin:', this.isLogin)
  //     if (this.isLogin) {
  //       return import('@/components/panels/UserProfilePanel')
  //     } else {
  //       return ''
  //     }
  //   }
  // },
  directives: {
    infiniteScroll: __WEBPACK_IMPORTED_MODULE_2_vue_infinite_scroll___default.a
  },
  methods: {
    loadMore: function loadMore() {
      this.busy = true;
      // this.$refs.infiniteScroll.$el.scrollTop = this.$refs.infiniteScroll.$el.scrollHeight
      this.getDiscussions();
      // window.scrollTo(0, document.body.scrollHeight)
      // var scrollingElement = (document.scrollingElement || document.body)
      // scrollingElement.scrollTop = scrollingElement.scrollHeight
      // scrollingElement.scrollIntoView(false)
      // scrollingElement.scrollIntoView({ behavior: 'smooth' })
      // scrollingElement.animate({ scrollTop: scrollingElement.scrollHeight }, 'slow')
    },
    getDiscussions: function getDiscussions() {
      var _this = this;

      // steem.api.getDiscussionsByBlog(
      // await steem.api.getDiscussionsByFeedAsync({tag:'anpigon', limit: 11})
      // steem.api.getDiscussionsByHot(
      // steem.api.getDiscussionsByPayout(
      // steem.api.getDiscussionsByCashout(
      // steem.api.getDiscussionsByTrending(
      var query = {
        tag: 'kr',
        limit: 11,
        start_permlink: this.next.permlink,
        start_author: this.next.author
        // 스팀잇 최근글 가져오기
      };__WEBPACK_IMPORTED_MODULE_0_steem___default.a.api.getDiscussionsByCreated(query, function (err, result) {
        // this.$refs.infiniteScroll.$el.scrollTop = this.$refs.infiniteScroll.$el.scrollHeight
        if (err) {
          console.log(err);
          return;
        }

        // 가져온 데이터를 items 에 담는다.
        var items = result.slice(0, 10).map(function (item) {
          var metadata = JSON.parse(item.json_metadata); // 메타데이터 JSON 파싱
          var image = metadata.image ? metadata.image[0] : ''; // 이미지 URL

          var totalPayoutValue = parseFloat(item.total_payout_value.split(' ')[0]);
          var curatorPayoutValue = parseFloat(item.curator_payout_value.split(' ')[0]);
          var pendingPayoutCalue = parseFloat(item.pending_payout_value.split(' ')[0]);
          item.payout_value = (totalPayoutValue + curatorPayoutValue + pendingPayoutCalue).toFixed(2);

          item.author_reputation = __WEBPACK_IMPORTED_MODULE_0_steem___default.a.formatter.reputation(item.author_reputation); // 저자 명성

          item.created = item.created;

          item.body = md.render(item.body).replace(/<\/?[^>]+(>|$)/g, '');

          return {
            id: item.id,
            image: image,
            author: item.author,
            author_reputation: item.author_reputation,
            title: item.title,
            created: item.created,
            body: item.body.substr(0, 200),
            category: item.category,
            permlink: item.permlink,
            url: item.url,
            payout_value: item.payout_value,
            net_votes: item.net_votes,
            children: item.children
          };
        });

        // items배열을 기존 discussions 배열과 합친다.
        _this.discussions = _this.discussions.concat(items);

        _this.next.exist = result.length > 10;
        // 스크롤 활성화
        if (_this.next.exist) {
          _this.next.permlink = result[10].permlink;
          _this.next.author = result[10].author;
          _this.busy = false;
        }
      });
    }
  },
  created: function created() {
    // this.getDiscussions()
    // console.log('isLogin', this.isLogin)
    // this.$store.dispatch('global/loadGlobalProperties')
    console.log('Main.vue created => type:', this.type);
  },
  deactivated: function deactivated() {
    this.busy = true;
  },
  activated: function activated() {
    this.busy = false;
    // console.log('username', this.$store.state.auth.username)
  },

  watch: {
    '$route': function $route(to, from) {
      console.log('to:', to, '\nfrom:', from);
    }
  }
});

/***/ }),

/***/ 127:
/***/ (function(module, exports) {

module.exports = {"aes-128-ecb":{"cipher":"AES","key":128,"iv":0,"mode":"ECB","type":"block"},"aes-192-ecb":{"cipher":"AES","key":192,"iv":0,"mode":"ECB","type":"block"},"aes-256-ecb":{"cipher":"AES","key":256,"iv":0,"mode":"ECB","type":"block"},"aes-128-cbc":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes-192-cbc":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes-256-cbc":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes128":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes192":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes256":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes-128-cfb":{"cipher":"AES","key":128,"iv":16,"mode":"CFB","type":"stream"},"aes-192-cfb":{"cipher":"AES","key":192,"iv":16,"mode":"CFB","type":"stream"},"aes-256-cfb":{"cipher":"AES","key":256,"iv":16,"mode":"CFB","type":"stream"},"aes-128-cfb8":{"cipher":"AES","key":128,"iv":16,"mode":"CFB8","type":"stream"},"aes-192-cfb8":{"cipher":"AES","key":192,"iv":16,"mode":"CFB8","type":"stream"},"aes-256-cfb8":{"cipher":"AES","key":256,"iv":16,"mode":"CFB8","type":"stream"},"aes-128-cfb1":{"cipher":"AES","key":128,"iv":16,"mode":"CFB1","type":"stream"},"aes-192-cfb1":{"cipher":"AES","key":192,"iv":16,"mode":"CFB1","type":"stream"},"aes-256-cfb1":{"cipher":"AES","key":256,"iv":16,"mode":"CFB1","type":"stream"},"aes-128-ofb":{"cipher":"AES","key":128,"iv":16,"mode":"OFB","type":"stream"},"aes-192-ofb":{"cipher":"AES","key":192,"iv":16,"mode":"OFB","type":"stream"},"aes-256-ofb":{"cipher":"AES","key":256,"iv":16,"mode":"OFB","type":"stream"},"aes-128-ctr":{"cipher":"AES","key":128,"iv":16,"mode":"CTR","type":"stream"},"aes-192-ctr":{"cipher":"AES","key":192,"iv":16,"mode":"CTR","type":"stream"},"aes-256-ctr":{"cipher":"AES","key":256,"iv":16,"mode":"CTR","type":"stream"},"aes-128-gcm":{"cipher":"AES","key":128,"iv":12,"mode":"GCM","type":"auth"},"aes-192-gcm":{"cipher":"AES","key":192,"iv":12,"mode":"GCM","type":"auth"},"aes-256-gcm":{"cipher":"AES","key":256,"iv":12,"mode":"GCM","type":"auth"}}

/***/ }),

/***/ 144:
/***/ (function(module, exports) {

module.exports = {"sha224WithRSAEncryption":{"sign":"rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"RSA-SHA224":{"sign":"ecdsa/rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"sha256WithRSAEncryption":{"sign":"rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"RSA-SHA256":{"sign":"ecdsa/rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"sha384WithRSAEncryption":{"sign":"rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"RSA-SHA384":{"sign":"ecdsa/rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"sha512WithRSAEncryption":{"sign":"rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA512":{"sign":"ecdsa/rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA1":{"sign":"rsa","hash":"sha1","id":"3021300906052b0e03021a05000414"},"ecdsa-with-SHA1":{"sign":"ecdsa","hash":"sha1","id":""},"sha256":{"sign":"ecdsa","hash":"sha256","id":""},"sha224":{"sign":"ecdsa","hash":"sha224","id":""},"sha384":{"sign":"ecdsa","hash":"sha384","id":""},"sha512":{"sign":"ecdsa","hash":"sha512","id":""},"DSA-SHA":{"sign":"dsa","hash":"sha1","id":""},"DSA-SHA1":{"sign":"dsa","hash":"sha1","id":""},"DSA":{"sign":"dsa","hash":"sha1","id":""},"DSA-WITH-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-WITH-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-WITH-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-WITH-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-RIPEMD160":{"sign":"dsa","hash":"rmd160","id":""},"ripemd160WithRSA":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"RSA-RIPEMD160":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"md5WithRSAEncryption":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"},"RSA-MD5":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"}}

/***/ }),

/***/ 160:
/***/ (function(module, exports) {

module.exports = {"1.3.132.0.10":"secp256k1","1.3.132.0.33":"p224","1.2.840.10045.3.1.1":"p192","1.2.840.10045.3.1.7":"p256","1.3.132.0.34":"p384","1.3.132.0.35":"p521"}

/***/ }),

/***/ 172:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_steem__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_steem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_steem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_remarkable__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_remarkable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_remarkable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_highlight_js__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_highlight_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_highlight_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Comments__ = __webpack_require__(622);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var md = new __WEBPACK_IMPORTED_MODULE_2_remarkable___default.a({
  html: true,
  linkify: true,
  typographer: true,
  quotes: '“”‘’',
  breaks: true
});

/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Comments: __WEBPACK_IMPORTED_MODULE_5__components_Comments__["a" /* default */] },
  data: function data() {
    return {
      loading: true,
      permlink: '',
      title: '',
      body: '',
      author: '',
      author_reputation: 0,
      category: '',
      children: 0,
      net_votes: 0,
      created: '',
      total_payout_value: 0,
      curator_payout_value: 0,
      pending_payout_value: 0,
      cashout_time: '',
      tags: [],
      comments: [],
      loadedComments: false
    };
  },

  computed: {
    // payout_value 금액 계산
    payoutValue: function payoutValue() {
      return (this.total_payout_value + this.curator_payout_value + this.pending_payout_value).toFixed(3);
    },
    payoutTime: function payoutTime() {
      var time = (new Date(this.cashout_time) - new Date()) / 1000;
      if (time > 86400) {
        return Math.round(time / 86400) + '일';
      } else if (time > 3600) {
        return Math.round(time / 3600) + '시간';
      } else if (time > 60) {
        return Math.round(time / 60) + '분';
      } else {
        return Math.round(time) + '초';
      }
    },
    commentsOffsetTop: function commentsOffsetTop() {
      // const { offsetTop, offsetHeight } = this.$refs.comments.$el
      // return offsetTop + offsetHeight + 60
      return this.loading ? 99999 : this.$refs.comments.$el.offsetTop;
    }
  },
  deactivated: function deactivated() {
    // console.log(window.location.hash)
    // if (window.location.hash === '#/') {
    // 해당 컴포넌트가 비활성화 되었을때, 컴포넌트를 메모리에서 제거한다.
    // this.$destroy()
    // }
  },

  // beforeRouteEnter (to, from, next) {
  //   steem.api.getContentAsync(to.params.author, to.params.permlink)
  //     .then(r => {
  //       console.log('beforeRouteEnter', r)
  //       // next(vm => vm.setData(null, r))
  //     })
  // },
  watch: {
    // 라우트가 변경되면 메소드를 다시 호출됩니다.
    // '$route': 'fetchData'
    '$route': function $route(to, from) {
      // 경로 변경에 반응하여...
      console.log('to:', to, '\nfrom:', from);
      this.fetchData();
    }
  },
  // beforeCreate () {
  // const author = this.$route.params.author // path의 author 파람값
  // const permlink = this.$route.params.permlink // path의 permlink 파람값
  // // console.log(`@${author}/${permlink}`)
  created: function created() {
    this.fetchData();
  },
  updated: function updated() {
    Array.prototype.forEach.call(document.querySelectorAll('article pre code'), function (block) {
      __WEBPACK_IMPORTED_MODULE_3_highlight_js___default.a.highlightBlock(block);
    });
    this.onScroll(); // 스크롤이 없는 화면이 있는 경우
  },

  methods: {
    fetchData: function fetchData() {
      var _this = this;

      var author = this.$route.params.author; // path의 author 파람값
      var permlink = this.$route.params.permlink; // path의 permlink 파람값
      if (!author || !permlink) return;
      // console.log(author, permlink)
      // console.log('$options', this.$options.data())
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.$data, this.$options.data()); // 데이터 초기화
      __WEBPACK_IMPORTED_MODULE_1_steem___default.a.api.getContentAsync(author, permlink).then(function (r) {
        // console.log(r)
        var metadata = JSON.parse(r.json_metadata);
        // console.log('metadata:', metadata)

        var body = r.body;
        // # 1. 이미지 URL이 있는 경우 이미지 태그로 변환(정규식 테스트 필요!!!)
        // body = body.replace(/(https?:\/\/.*\.(?:jpe?g|gif|png)(\?.*)?(^[\n|\r\n])))/ig, '<img src="$1">')
        // body = body.replace(/(^http(s)?:\/\/steemit(dev|stage)?images.com\/.+)/g, '<img src="$1">')
        // body = body.replace(/(https?:\/\/steemit(dev|stage)?images.com(\/([0-9]+x[0-9]+))?\/.+)/g, '<img src="$1">')
        // body = body.replace(/([^\\(|>|'|"|\\/]https?:\/\/.*\.(?:jpe?g|gif|png)(\?.*)?)/ig, '<img src="$1">')
        body = body.replace(/(https?:\/\/steemit(dev|stage)?images.com(\/([0-9]+x[0-9]+))?\/.*\.(?:jpe?g|gif|png)(\?.*)?)/gi, '<img src="$1">');
        body = body.replace(/[^\\(|>|'|"|\\/](https?:\/\/(?:[-a-zA-Z0-9._]*[-a-zA-Z0-9])(?::\d{2,5})?(?:[/?#](?:[^\s"'<>\][()]*[^\s"'<>\][().,])?(?:(?:\.(?:tiff?|jpe?g|gif|png|svg|ico)|ipfs\/[a-z\d]{40,}))))/gi, '<img src="$1"/>');
        // console.log(body)

        // # 2. 유튜브 URL이 있는 경우 동영상 태그로 치환
        body = body.replace(/https:\/\/www.youtube.com\/watch\?[a-zA-Z]=([a-zA-Z0-9]*)/gi, '<div class="videoWrapper"><iframe src="https://www.youtube.com/embed/$1"></iframe></div></p>');
        body = body.replace(/https:\/\/youtu.be\/([\w]*)/gi, '<div class="videoWrapper"><iframe src="https://www.youtube.com/embed/$1"></iframe></div></p>');

        // # 3. @유저명 치환(?)

        // # 4. #태그 치환(?)

        // # 9. 마크다운인 경우 HTML 로 변환
        body = md.render(body);
        // console.log('md -> html:', body)

        _this.permlink = r.permlink;
        _this.title = r.title;
        _this.body = body;
        _this.category = r.category;
        _this.children = r.children;
        _this.net_votes = r.net_votes;
        _this.author = r.author;
        _this.created = r.created;
        _this.author_reputation = r.author_reputation;
        _this.total_payout_value = parseFloat(r.total_payout_value.split(' ')[0]);
        _this.curator_payout_value = parseFloat(r.curator_payout_value.split(' ')[0]);
        _this.pending_payout_value = parseFloat(r.pending_payout_value.split(' ')[0]);
        _this.cashout_time = r.cashout_time;
        _this.tags = metadata.tags;

        _this.loadedComments = r.children === 0;
      }).catch(function (e) {
        return console.log(e);
      }).finally(function () {
        return _this.loading = false;
      });
    },
    onScroll: function onScroll() {
      var windowOffsetTop = window.pageYOffset || document.documentElement.scrollTop;
      var windowOffsetBottom = windowOffsetTop + window.innerHeight;
      // if (!this.loadedComments && (this.commentsOffsetTop > windowOffsetBottom - 10 || this.commentsOffsetTop < windowOffsetBottom + 10)) {
      // console.log(this.commentsOffsetTop, windowOffsetBottom)
      if (!this.loadedComments && windowOffsetBottom > this.commentsOffsetTop) {
        console.log('댓글 영역 도달!!!');
        this.getComments();
      }
    },

    getComments: __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.debounce(function () {
      var _this2 = this;

      console.log('댓글 로드!!!');
      var path = '/' + this.category + '/@' + this.author + '/' + this.permlink; // 댓글을 가져올 글의 path
      console.log('path:', path);
      __WEBPACK_IMPORTED_MODULE_1_steem___default.a.api.getStateAsync(path).then(function (_ref) {
        var content = _ref.content;

        console.log(content);
        _this2.loadedComments = true;

        // 댓글 목록 조회
        var root = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.find(content, { depth: 0 }); // content에서 본문만 가져오기
        addComments(content, root); // 재귀함수 호출
        _this2.comments = root.comments;
      });
    }, 500)
  }
});

function addComments(contents, root) {
  if (root.children > 0) {
    // root가 children를 가지고 있으면 실행
    if (!root.comments) root.comments = []; // root의 댓글을 담을 comments 변수 초기화
    root.replies.forEach(function (key) {
      // 댓글key를 가지고 있는 root.replies 배열을 반복하여 contents에서 key와 매칭되는 댓글 데이터 가져옴
      var comment = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.pick(contents[key], ['id', 'author', 'author_reputation', 'body', 'created', 'net_votes', 'permlink', 'parent_author', 'parent_permlink', 'url', 'children', 'depth', 'replies', 'total_payout_value', 'curator_payout_value', 'pending_payout_value']);
      comment.payout_value = (parseFloat(comment.total_payout_value.split(' ')[0]) + parseFloat(comment.curator_payout_value.split(' ')[0]) + parseFloat(comment.pending_payout_value.split(' ')[0])).toFixed(2);
      root.comments.push(comment); // root의 댓글목록에 추가
      addComments(contents, comment); // 현재 댓글에 자식 댓글이 있는지 찾기 위해 재귀함수 호출
    });
  }
}

/***/ }),

/***/ 173:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Comments',
  props: ['comments']
});

/***/ }),

/***/ 174:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_steem__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_steem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_steem__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'login',
  data: function data() {
    return {
      valid: false,
      username: '',
      password: '',
      usernameRules: [function (v) {
        return !!v || 'Username is required';
      }],
      passwordRules: [function (v) {
        return !v || __WEBPACK_IMPORTED_MODULE_0_steem___default.a.auth.isWif(v) || 'Password is invalid';
      }],
      busy: false,
      autoLogin: !!window.localStorage.getItem('autoLogin')
    };
  },
  deactivated: function deactivated() {
    this.$destroy();
  },

  methods: {
    login: function login() {
      var _this = this;

      if (this.$refs.form.validate()) {
        this.busy = true;
        __WEBPACK_IMPORTED_MODULE_0_steem___default.a.api.lookupAccountNamesAsync([this.username]).then(function (usernames) {
          console.log(usernames);
          if (!usernames || !usernames[0]) return alert('"' + _this.username + '" \uC0AC\uC6A9\uC790\uB97C \uCC3E\uC744 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4.');
          _this.$store.dispatch('auth/login', {
            username: _this.username,
            password: _this.password
          });
          console.log('this.autoLogin:', _this.autoLogin, _this.autoLogin === true);
          if (_this.autoLogin) {
            window.localStorage.setItem('autoLogin', _this.autoLogin);
            window.localStorage.setItem('username', _this.username);
            window.localStorage.setItem('password', _this.password);
          } else {
            window.localStorage.removeItem('autoLogin');
            window.localStorage.removeItem('username');
            window.localStorage.removeItem('password');
          }
          // this.$router.replace(this.$route.query.redirect || '/')
          _this.$router.go(-1);
        }).finally(function () {
          return _this.busy = false;
        });
      }
    }
  }
});

/***/ }),

/***/ 186:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetify_dist_vuetify_min_css__ = __webpack_require__(629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetify_dist_vuetify_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuetify_dist_vuetify_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__(630);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.







__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

// 작성일자 표시
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('filterCreated', function (value) {
  if (!value) return '';
  var now = new Date();
  var created = new Date(value.toString() + 'Z');
  var elapsedSeconds = (now - created) / 1000; // 경과 시간(초)
  if (elapsedSeconds < 60) {
    return Math.round(elapsedSeconds) + '초 전';
  } else if (elapsedSeconds < 360) {
    return Math.round(elapsedSeconds / 60) + '분 전';
  } else if (elapsedSeconds < 8640) {
    return Math.round(elapsedSeconds / 60) + '시간 전';
  } else if (elapsedSeconds < 207360) {
    return '어제';
  } else {
    return (now.getFullYear() !== created.getFullYear() ? created.getFullYear() + '년 ' : '') + (created.getMonth() + 1) + '월 ' + created.getDate() + '일';
  }
});

// 명성 계산
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('filterReputation', function (t) {
  if (!t) return t;
  t = parseInt(t);
  var e = String(t);
  var r = e.charAt(0) === '-';
  e = r ? e.substring(1) : e;
  var n = e;
  var i = parseInt(n.substring(0, 4));
  var o = Math.log(i) / Math.log(10);
  var s = n.length - 1;
  var a = s + (o - parseInt(o));
  if (isNaN(a)) a = 0;else {
    a = Math.max(a - 9, 0);
    a *= r ? -1 : 1;
    a = 9 * a + 25;
    a = parseInt(a);
  }
  return a;
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ 188:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(98);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_88ca0d70_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(201);
function injectStyle (ssrContext) {
  __webpack_require__(189)
}
var normalizeComponent = __webpack_require__(25)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_88ca0d70_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 189:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 201:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"inspire"}},[_c('v-navigation-drawer',{attrs:{"fixed":"","temporary":"","app":""},model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}},[_c('v-toolbar',{attrs:{"color":"teal accent-4","dark":""}},[_c('v-toolbar-side-icon',{on:{"click":function($event){$event.stopPropagation();_vm.drawer = false}}},[_c('v-icon',[_vm._v("arrow_back_ios")])],1),_vm._v(" "),_c('v-toolbar-title',[_vm._v("Steemlog")])],1),_vm._v(" "),_c('v-list',[(_vm.username)?_c('v-list-tile',{class:{ 'primary--text': _vm.$route.name === 'Feed' },attrs:{"to":'/@' + _vm.username + '/feed',"replace":"","ripple":"","inactive":_vm.$route.name === 'Feed'}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v("rss_feed")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("피드")])],1)],1):_vm._e(),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list-tile',{class:{ 'primary--text': _vm.$route.name === 'Created' },attrs:{"to":"/created","replace":"","ripple":"","inactive":_vm.$route.name === 'Created'}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v("fiber_new")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("최신글")])],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list-tile',{class:{ 'primary--text': _vm.$route.name === 'Hot' },attrs:{"to":"/hot","replace":"","ripple":"","inactive":_vm.$route.name === 'Hot'}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v("whatshot")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("인기글")])],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list-tile',{class:{ 'primary--text': _vm.$route.name === 'Trending' },attrs:{"to":"/trending","replace":"","ripple":"","inactive":_vm.$route.name === 'Trending'}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v("trending_up")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("대세글")])],1)],1)],1)],1),_vm._v(" "),_c('v-toolbar',{directives:[{name:"show",rawName:"v-show",value:(_vm.isMainComponent),expression:"isMainComponent"}],attrs:{"color":"teal accent-4","dark":"","fixed":"","app":""}},[_c('v-toolbar-side-icon',{staticClass:"hidden-md-and-up",on:{"click":function($event){$event.stopPropagation();_vm.drawer = !_vm.drawer}}}),_vm._v(" "),_c('v-toolbar-title',[_vm._v("Steemlog ["+_vm._s(_vm.$route.meta.name)+"]")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-items',{staticClass:"hidden-sm-and-down"},[(_vm.username)?_c('v-btn',{attrs:{"flat":"","to":'/@' + _vm.username + '/feed',"replace":"","inactive":_vm.$route.name === 'Feed',"input-value":_vm.$route.name === 'Feed'}},[_vm._v("피드")]):_vm._e(),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","to":"/created","exact":"","input-value":_vm.$route.name === 'Created'}},[_vm._v("최신글")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","to":"/hot","input-value":_vm.$route.name === 'Hot'}},[_vm._v("인기글")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","to":"/trending","input-value":_vm.$route.name === 'Trending'}},[_vm._v("대세글")])],1),_vm._v(" "),(!_vm.username)?_c('v-toolbar-items',[_c('v-btn',{attrs:{"flat":"","small":"","to":"/login"}},[_vm._v("로그인")])],1):_vm._e(),_vm._v(" "),(_vm.username)?_c('v-btn',{attrs:{"icon":"","large":""}},[_c('v-icon',[_vm._v("notifications")])],1):_vm._e(),_vm._v(" "),(_vm.username)?_c('v-btn',{attrs:{"icon":""}},[_c('v-avatar',{attrs:{"color":"white","size":"36"}},[_c('img',{attrs:{"src":'https://steemitimages.com/u/' + _vm.username + '/avatar',"alt":"avatar","onerror":"this.src='https://steemitimages.com/u/monawoo/avatar/small'"}})])],1):_vm._e()],1),_vm._v(" "),_c('v-toolbar',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isMainComponent),expression:"!isMainComponent"}],attrs:{"fixed":"","app":""}},[_c('v-toolbar-side-icon',{on:{"click":function($event){$event.stopPropagation();_vm.$router.go(-1)}}},[_c('v-icon',[_vm._v("arrow_back_ios")])],1),_vm._v(" "),_c('v-toolbar-title',{staticClass:"ml-0"},[_vm._v("뒤로가기")])],1),_vm._v(" "),_c('v-content',[_c('transition',{attrs:{"name":"fade","mode":"out-in","appear":""}},[_c('keep-alive',[_c('router-view')],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 202:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Main__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_PostView__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Login__ = __webpack_require__(626);


 // Main 컴포넌트 임포트
 // PostView 컴포넌트 임포트


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [
  // {
  //   path: '/',
  //   alias: ['/trending', '/created', '/hot'],
  //   name: 'Main',
  //   component: Main
  // },
  // {
  //   path: '/@:author/feed', redirect: { name: 'Main' }
  //   // name: 'Main',
  //   // component: Main
  // },
  {
    path: '/',
    name: 'Main',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Main__["a" /* default */],
    children: [
    // { path: 'default', redirect: { name: 'Created' } },
    { path: 'default', redirect: { name: 'Created' }, alias: '' }, { name: 'Feed', path: '/@:username/feed', component: function component() {
        return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 671));
      }, meta: { main: true, name: '피드' }, props: true }, { name: 'Created', path: '/created', component: function component() {
        return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 672));
      }, meta: { main: true, name: '최신글' } }, { name: 'Hot', path: '/hot', component: function component() {
        return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 673));
      }, meta: { main: true, name: '인기글' } }, { name: 'Trending', path: '/trending', component: function component() {
        return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 674));
      }, meta: { main: true, name: '대세글' } }]
  }, {
    path: '/@:author/:permlink',
    // alias: '/:category/@:author/:permlink',
    name: 'PostView',
    component: __WEBPACK_IMPORTED_MODULE_3__components_PostView__["a" /* default */],
    props: true
  }, {
    path: '/@:author/:permlink/vote',
    // alias: '/:category/@:author/:permlink/vote',
    name: 'VoteHistory',
    component: function component() {
      return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 675));
    }
  }, {
    path: '/login',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Login__["a" /* default */]
  }, { path: '*', name: 'NotFound', component: { template: '<div>Not Found</div>' } }]
}));

/***/ }),

/***/ 204:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Main_vue__ = __webpack_require__(108);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b7a7634_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Main_vue__ = __webpack_require__(440);
function injectStyle (ssrContext) {
  __webpack_require__(205)
}
var normalizeComponent = __webpack_require__(25)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1b7a7634"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Main_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b7a7634_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 205:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 234:
/***/ (function(module, exports) {

module.exports = {"transport":"http","websocket":"wss://gtg.steem.house:8090","uri":"https://api.steemit.com","url":"","dev_uri":"https://api.steemitdev.com","stage_uri":"https://api.steemitstage.com","address_prefix":"STM","chain_id":"0000000000000000000000000000000000000000000000000000000000000000"}

/***/ }),

/***/ 242:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 250:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 252:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 266:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 277:
/***/ (function(module, exports) {

module.exports = {"name":"bigi","version":"1.4.2","description":"Big integers.","keywords":["cryptography","math","bitcoin","arbitrary","precision","arithmetic","big","integer","int","number","biginteger","bigint","bignumber","decimal","float"],"devDependencies":{"coveralls":"^2.11.2","istanbul":"^0.3.5","jshint":"^2.5.1","mocha":"^2.1.0","mochify":"^2.1.0"},"repository":{"url":"https://github.com/cryptocoinjs/bigi","type":"git"},"main":"./lib/index.js","scripts":{"browser-test":"./node_modules/.bin/mochify --wd -R spec","test":"./node_modules/.bin/_mocha -- test/*.js","jshint":"./node_modules/.bin/jshint --config jshint.json lib/*.js ; true","unit":"./node_modules/.bin/mocha","coverage":"./node_modules/.bin/istanbul cover ./node_modules/.bin/_mocha -- --reporter list test/*.js","coveralls":"npm run-script coverage && node ./node_modules/.bin/coveralls < coverage/lcov.info"},"dependencies":{},"testling":{"files":"test/*.js","harness":"mocha","browsers":["ie/9..latest","firefox/latest","chrome/latest","safari/6.0..latest","iphone/6.0..latest","android-browser/4.2..latest"]}}

/***/ }),

/***/ 280:
/***/ (function(module, exports) {

module.exports = {"secp128r1":{"p":"fffffffdffffffffffffffffffffffff","a":"fffffffdfffffffffffffffffffffffc","b":"e87579c11079f43dd824993c2cee5ed3","n":"fffffffe0000000075a30d1b9038a115","h":"01","Gx":"161ff7528b899b2d0c28607ca52c5b86","Gy":"cf5ac8395bafeb13c02da292dded7a83"},"secp160k1":{"p":"fffffffffffffffffffffffffffffffeffffac73","a":"00","b":"07","n":"0100000000000000000001b8fa16dfab9aca16b6b3","h":"01","Gx":"3b4c382ce37aa192a4019e763036f4f5dd4d7ebb","Gy":"938cf935318fdced6bc28286531733c3f03c4fee"},"secp160r1":{"p":"ffffffffffffffffffffffffffffffff7fffffff","a":"ffffffffffffffffffffffffffffffff7ffffffc","b":"1c97befc54bd7a8b65acf89f81d4d4adc565fa45","n":"0100000000000000000001f4c8f927aed3ca752257","h":"01","Gx":"4a96b5688ef573284664698968c38bb913cbfc82","Gy":"23a628553168947d59dcc912042351377ac5fb32"},"secp192k1":{"p":"fffffffffffffffffffffffffffffffffffffffeffffee37","a":"00","b":"03","n":"fffffffffffffffffffffffe26f2fc170f69466a74defd8d","h":"01","Gx":"db4ff10ec057e9ae26b07d0280b7f4341da5d1b1eae06c7d","Gy":"9b2f2f6d9c5628a7844163d015be86344082aa88d95e2f9d"},"secp192r1":{"p":"fffffffffffffffffffffffffffffffeffffffffffffffff","a":"fffffffffffffffffffffffffffffffefffffffffffffffc","b":"64210519e59c80e70fa7e9ab72243049feb8deecc146b9b1","n":"ffffffffffffffffffffffff99def836146bc9b1b4d22831","h":"01","Gx":"188da80eb03090f67cbf20eb43a18800f4ff0afd82ff1012","Gy":"07192b95ffc8da78631011ed6b24cdd573f977a11e794811"},"secp256k1":{"p":"fffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f","a":"00","b":"07","n":"fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141","h":"01","Gx":"79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798","Gy":"483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8"},"secp256r1":{"p":"ffffffff00000001000000000000000000000000ffffffffffffffffffffffff","a":"ffffffff00000001000000000000000000000000fffffffffffffffffffffffc","b":"5ac635d8aa3a93e7b3ebbd55769886bc651d06b0cc53b0f63bce3c3e27d2604b","n":"ffffffff00000000ffffffffffffffffbce6faada7179e84f3b9cac2fc632551","h":"01","Gx":"6b17d1f2e12c4247f8bce6e563a440f277037d812deb33a0f4a13945d898c296","Gy":"4fe342e2fe1a7f9b8ee7eb4a7c0f9e162bce33576b315ececbb6406837bf51f5"}}

/***/ }),

/***/ 301:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 302:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 303:
/***/ (function(module, exports) {

module.exports = {"modp1":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"},"modp2":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"},"modp5":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"},"modp14":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"},"modp15":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"},"modp16":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"},"modp17":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"},"modp18":{"gen":"02","prime":"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"}}

/***/ }),

/***/ 307:
/***/ (function(module, exports) {

module.exports = {"name":"elliptic","version":"6.4.1","description":"EC cryptography","main":"lib/elliptic.js","files":["lib"],"scripts":{"jscs":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","jshint":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","lint":"npm run jscs && npm run jshint","unit":"istanbul test _mocha --reporter=spec test/index.js","test":"npm run lint && npm run unit","version":"grunt dist && git add dist/"},"repository":{"type":"git","url":"git@github.com:indutny/elliptic"},"keywords":["EC","Elliptic","curve","Cryptography"],"author":"Fedor Indutny <fedor@indutny.com>","license":"MIT","bugs":{"url":"https://github.com/indutny/elliptic/issues"},"homepage":"https://github.com/indutny/elliptic","devDependencies":{"brfs":"^1.4.3","coveralls":"^2.11.3","grunt":"^0.4.5","grunt-browserify":"^5.0.0","grunt-cli":"^1.2.0","grunt-contrib-connect":"^1.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^1.0.1","grunt-mocha-istanbul":"^3.0.1","grunt-saucelabs":"^8.6.2","istanbul":"^0.4.2","jscs":"^2.9.0","jshint":"^2.6.0","mocha":"^2.1.0"},"dependencies":{"bn.js":"^4.4.0","brorand":"^1.0.1","hash.js":"^1.0.0","hmac-drbg":"^1.0.0","inherits":"^2.0.1","minimalistic-assert":"^1.0.0","minimalistic-crypto-utils":"^1.0.0"}}

/***/ }),

/***/ 340:
/***/ (function(module, exports) {

module.exports = {"2.16.840.1.101.3.4.1.1":"aes-128-ecb","2.16.840.1.101.3.4.1.2":"aes-128-cbc","2.16.840.1.101.3.4.1.3":"aes-128-ofb","2.16.840.1.101.3.4.1.4":"aes-128-cfb","2.16.840.1.101.3.4.1.21":"aes-192-ecb","2.16.840.1.101.3.4.1.22":"aes-192-cbc","2.16.840.1.101.3.4.1.23":"aes-192-ofb","2.16.840.1.101.3.4.1.24":"aes-192-cfb","2.16.840.1.101.3.4.1.41":"aes-256-ecb","2.16.840.1.101.3.4.1.42":"aes-256-cbc","2.16.840.1.101.3.4.1.43":"aes-256-ofb","2.16.840.1.101.3.4.1.44":"aes-256-cfb"}

/***/ }),

/***/ 440:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fill-height":"","grid-list-md":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c(_vm.UserProfilePanel,{tag:"component"}),_vm._v(" "),(false)?_c('v-card',{staticClass:"mt-1"},[_c('v-card-title',{attrs:{"primary-title":""}},[_c('h3',{staticClass:"mb-0",staticStyle:{"font-size":"18px","font-weight":"bold"}},[_vm._v("인기있는 태그")])]),_vm._v(" "),_c('v-card-text',{staticClass:"pt-0"},[_c('ul',{staticClass:"trends",staticStyle:{"list-style":"none","margin":"0","padding":"0","font-weight":"bold","font-size":"1.1em"}},[_c('li',{staticStyle:{"line-height":"17px","margin-bottom":"10px"}},[_c('a',{staticClass:"trend-name",attrs:{"href":"#"}},[_vm._v("life")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"trend-name",attrs:{"href":"#"}},[_vm._v("photography")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"trend-name",attrs:{"href":"#"}},[_vm._v("kr")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"trend-name",attrs:{"href":"#"}},[_vm._v("steemit")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"trend-name",attrs:{"href":"#"}},[_vm._v("art")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"trend-name",attrs:{"href":"#"}},[_vm._v("bitcoin")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"trend-name",attrs:{"href":"#"}},[_vm._v("introduceyourself")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"trend-name",attrs:{"href":"#"}},[_vm._v("spanish")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"trend-name",attrs:{"href":"#"}},[_vm._v("travel")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"trend-name",attrs:{"href":"#"}},[_vm._v("cryptocurrency")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"trend-name",attrs:{"href":"#"}},[_vm._v("food")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"trend-name",attrs:{"href":"#"}},[_vm._v("steem")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"trend-name",attrs:{"href":"#"}},[_vm._v("busy")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"trend-name",attrs:{"href":"#"}},[_vm._v("blog")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"trend-name",attrs:{"href":"#"}},[_vm._v("funny")])])]),_vm._v(" "),_c('a',{staticStyle:{"font-weight":"500","color":"#99aab5","display":"inline-block","margin":"12px 0","font-size":"1.2em"},attrs:{"href":"#"}},[_vm._v("더 보기")])])],1):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md9":""}},[_c('keep-alive',[_c('router-view')],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 441:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PostView_vue__ = __webpack_require__(172);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49613e4b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PostView_vue__ = __webpack_require__(625);
function injectStyle (ssrContext) {
  __webpack_require__(442)
}
var normalizeComponent = __webpack_require__(25)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PostView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49613e4b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PostView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 442:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 622:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Comments_vue__ = __webpack_require__(173);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b3bd5c6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Comments_vue__ = __webpack_require__(624);
function injectStyle (ssrContext) {
  __webpack_require__(623)
}
var normalizeComponent = __webpack_require__(25)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Comments_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b3bd5c6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Comments_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 623:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 624:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.comments),function(c,idx){return [_c('v-layout',{key:c.id},[(c.depth > 1)?_c('div',{attrs:{"xs1":""}},[_c('span',{staticClass:"depth"})]):_vm._e(),_vm._v(" "),_c('v-flex',[((c.depth + idx) > 1)?_c('v-divider'):_vm._e(),_vm._v(" "),_c('v-card',{staticClass:"comments",staticStyle:{"padding":"0"},attrs:{"flat":""}},[_c('v-card-title',{staticClass:"grey--text pb-1"},[_vm._v("\n              "+_vm._s(c.author)+" \n              "),_c('span',{staticClass:"reputation pl-1 pr-1"},[_vm._v("("+_vm._s(_vm._f("filterReputation")(c.author_reputation))+")")]),_vm._v("\n              · "+_vm._s(_vm._f("filterCreated")(c.created))+"\n            ")]),_vm._v(" "),_c('v-card-text',{staticClass:"pt-0 pb-0 overflow-hidden",domProps:{"innerHTML":_vm._s(c.body)}}),_vm._v(" "),_c('v-card-actions',{staticClass:"pr-3"},[_c('v-btn',{attrs:{"small":"","flat":""}},[_c('v-icon',{staticClass:"mr-2",attrs:{"left":"","dark":""}},[_vm._v("favorite_border")]),_vm._v(" 좋아요 ("+_vm._s(c.net_votes)+")")],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('strong',[_vm._v("$"+_vm._s(c.payout_value))])],1)],1),_vm._v(" "),_c('Comments',{attrs:{"comments":c.comments}})],1)],1)]})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 625:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fill-height":"","fluid":"","grid-list-md":""}},[(_vm.loading)?_c('v-layout',{attrs:{"align-center":"","justify-center":""}},[_c('v-progress-circular',{attrs:{"size":"50","color":"primary","indeterminate":""}})],1):_vm._e(),_vm._v(" "),(!_vm.loading)?_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","md8":"","offset-md2":""}},[_c('v-layout',{directives:[{name:"scroll",rawName:"v-scroll",value:(_vm.onScroll),expression:"onScroll"}],attrs:{"justify-start":"","column":"","fill-height":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('v-card-title',{staticClass:"headline pb-0"},[_vm._v("\r\n              "+_vm._s(_vm.title)+"\r\n            ")]),_vm._v(" "),_c('v-layout',[_c('v-flex',{staticClass:"pr-0",attrs:{"xs7":""}},[_c('v-list',{staticClass:"pt-0"},[_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-avatar',[_c('img',{attrs:{"src":'https://steemitimages.com/u/' + _vm.author + '/avatar/small',"alt":"avatar","onerror":"this.src='https://steemitimages.com/u/monawoo/avatar/small'"}})]),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.author)+" "),_c('span',{staticClass:"reputation"},[_vm._v("("+_vm._s(_vm._f("filterReputation")(_vm.author_reputation))+")")])]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm._f("filterCreated")(_vm.created))+" · "+_vm._s(_vm.category))])],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"pr-4 pt-3",attrs:{"xs5":"","text-xs-right":""}},[_c('div',[_c('router-link',{staticClass:"mr-1",attrs:{"to":'/@' + _vm.author + '/' + _vm.permlink + '/vote'}},[_vm._v("좋아요 "+_vm._s(_vm.net_votes))]),_vm._v(" "),_vm._v("\r\n                   · 댓글 "+_vm._s(_vm.children)+"\r\n                ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""}},[_c('strong',{attrs:{"slot":"activator"},slot:"activator"},[_vm._v("$"+_vm._s(_vm.payoutValue))]),_vm._v(" "),(_vm.pending_payout_value > 0)?_c('div',[_vm._v(" 예상 보상금액: $"+_vm._s(_vm.payoutValue)),_c('br'),_vm._v(" "),_vm._v("\r\n                  "+_vm._s(_vm.payoutTime)+" 후")]):_vm._e(),_vm._v(" "),(_vm.pending_payout_value === 0)?_c('div',[_vm._v("\r\n                     지급된 보상 $"+_vm._s(_vm.payoutValue)),_c('br'),_vm._v("\r\n                    - 저자 $"+_vm._s(_vm.total_payout_value)),_c('br'),_vm._v("\r\n                    - 큐레이터 $"+_vm._s(_vm.curator_payout_value)+"\r\n                  ")]):_vm._e()])],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',[_c('article',{domProps:{"innerHTML":_vm._s(_vm.body)}})]),_vm._v(" "),_c('v-card-text',[_vm._l((_vm.tags),function(tag){return [_c('a',{key:tag,staticClass:"tag",attrs:{"href":"javascript:false"}},[_vm._v("#"+_vm._s(tag))])]})],2)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-subheader',{staticClass:"pl-0"},[_vm._v("댓글 ("+_vm._s(_vm.children)+")")]),_vm._v(" "),_c('v-card',{ref:"comments"},[(!_vm.loadedComments)?_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"align-center":"","justify-center":""}},[_c('v-progress-circular',{attrs:{"color":"primary","indeterminate":""}})],1)],1):_vm._e(),_vm._v(" "),(_vm.loadedComments)?[_c('Comments',{attrs:{"comments":_vm.comments}})]:_vm._e()],2)],1)],1)],1)],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 626:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(174);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c3214804_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(627);
var normalizeComponent = __webpack_require__(25)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c3214804_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 627:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"_fluid":"","fill-height":"","grid-list-md":""}},[_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","sm8":"","offset-sm2":"","lg6":"","offset-lg3":""}},[_c('v-card',[_c('v-card-text',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs10":"","offset-xs1":"","md8":"","offset-md2":""}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-title',[_c('h1',{staticClass:"headline"},[_vm._v("로그인하기")])]),_vm._v(" "),_c('v-card-text',[_c('v-form',{ref:"form",attrs:{"lazy-validation":""},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-text-field',{attrs:{"prepend-icon":"person","autofocus":"","label":"Username","rules":_vm.usernameRules,"persistent-hint":"","required":""},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.login($event)}},model:{value:(_vm.username),callback:function ($$v) {_vm.username=$$v},expression:"username"}}),_vm._v(" "),_c('v-text-field',{attrs:{"prepend-icon":"lock","type":"password","label":"Password","rules":_vm.passwordRules,"persistent-hint":"","hint":"로그인에는 항상 포스팅키를 사용하시기를 권장합니다."},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.login($event)}},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}}),_vm._v(" "),_c('v-switch',{staticClass:"pb-0",attrs:{"label":"자동 로그인"},model:{value:(_vm.autoLogin),callback:function ($$v) {_vm.autoLogin=$$v},expression:"autoLogin"}})],1)],1),_vm._v(" "),_c('v-card-actions',{staticClass:"pt-0"},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","loading":_vm.busy,"disabled":_vm.busy},on:{"click":function($event){$event.preventDefault();return _vm.login($event)}}},[_vm._v("로그인")])],1)],1)],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 629:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 630:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_auth__ = __webpack_require__(631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_global__ = __webpack_require__(632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_account__ = __webpack_require__(663);






__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  modules: {
    global: __WEBPACK_IMPORTED_MODULE_3__modules_global__["a" /* default */],
    account: __WEBPACK_IMPORTED_MODULE_4__modules_account__["a" /* default */],
    auth: __WEBPACK_IMPORTED_MODULE_2__modules_auth__["a" /* default */]
  }
}));

/***/ }),

/***/ 631:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
  username: window.localStorage.getItem('username') || window.sessionStorage.getItem('username') || '',
  password: window.localStorage.getItem('password') || window.sessionStorage.getItem('password') || ''
};

var getters = {
  // isLogin: state => !!state.username,
  isLogin: function isLogin(state) {
    return !!state.username;
  }
};

var actions = {
  login: function login(_ref, auth) {
    var commit = _ref.commit;

    commit('login', auth);
    window.sessionStorage.setItem('username', auth.username);
    window.sessionStorage.setItem('password', auth.password);
  }
};

var mutations = {
  login: function login(state, _ref2) {
    var username = _ref2.username,
        password = _ref2.password;

    state.username = username;
    state.password = password;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ 632:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_steem__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_steem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_steem__);




var state = {
  totalVestingFundSteem: 0,
  totalVestingShares: 0,
  rewardBalance: 0,
  recentClaims: 0,
  price: 0
};

var getters = {};

var actions = {
  loadGlobalProperties: function loadGlobalProperties(_ref) {
    var commit = _ref.commit;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([__WEBPACK_IMPORTED_MODULE_2_steem___default.a.api.getDynamicGlobalPropertiesAsync(), __WEBPACK_IMPORTED_MODULE_2_steem___default.a.api.getRewardFundAsync('post'), __WEBPACK_IMPORTED_MODULE_2_steem___default.a.api.getCurrentMedianHistoryPriceAsync()]).then(function (_ref2) {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref2, 3),
          global = _ref3[0],
          rewardFund = _ref3[1],
          price = _ref3[2];

      var base = parseFloat(price.base.split(' ')[0]);
      var quote = parseFloat(price.quote.split(' ')[0]);
      commit('setGlobalProperties', {
        totalVestingFundSteem: parseFloat(global.total_vesting_fund_steem.split(' ')[0]),
        totalVestingShares: parseFloat(global.total_vesting_shares.split(' ')[0]),
        rewardBalance: parseFloat(rewardFund.reward_balance.split(' ')[0]),
        recentClaims: rewardFund.recent_claims,
        price: base / quote
      });
    });
  }
};

var mutations = {
  setGlobalProperties: function setGlobalProperties(state, global) {
    for (var key in global) {
      state[key] = global[key];
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ 663:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_steem__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_steem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_steem__);





var state = {
  username: '',
  name: '',
  profileImage: '',
  coverImage: '',
  about: '',
  reputation: 0,
  postCount: 0,
  lastVoteTime: '',
  votingPower: 0,
  vestingShares: 0,
  delegatedVestingShares: 0,
  receivedVestingShares: 0
};

var getters = {};

var actions = {
  loadAccount: function loadAccount(_ref, username) {
    var _this = this;

    var commit = _ref.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var _ref2, _ref3, account, _JSON$parse, profile, data;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_3_steem___default.a.api.getAccountsAsync([username]);

            case 2:
              _ref2 = _context.sent;
              _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref2, 1);
              account = _ref3[0];
              _JSON$parse = JSON.parse(account.json_metadata), profile = _JSON$parse.profile;

              console.log('account', account, profile);

              data = {
                name: profile.name,
                coverImage: profile.cover_image,
                profileImage: profile.profile_image,
                about: profile.about,
                reputation: __WEBPACK_IMPORTED_MODULE_3_steem___default.a.formatter.reputation(account.reputation), // 명성도
                postCount: account.post_count, // 포스트 갯수
                lastVoteTime: account.last_vote_time,
                votingPower: account.voting_power,
                vestingShares: parseFloat(account.vesting_shares.split(' ')[0]),
                delegatedVestingShares: parseFloat(account.delegated_vesting_shares.split(' ')[0]),
                receivedVestingShares: parseFloat(account.received_vesting_shares.split(' ')[0])
              };


              commit('setAccount', data);

            case 9:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
};

var mutations = {
  setAccount: function setAccount(state, account) {
    // console.log('account:', account)
    for (var key in account) {
      state[key] = account[key];
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ 98:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(97);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      drawer: false
    };
  },
  props: {
    source: String
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])('auth', ['username']), {
    isMainComponent: function isMainComponent() {
      return !!this.$route.meta.main;
    }
  }),
  // watch: {
  //   '$route' (to, from) {
  //     console.log('to:', to, '\nfrom:', from)
  //   }
  // },
  created: function created() {
    console.log('App.vue created => Main:', this.isMainComponent);
    console.log(this.$route);
  }
});

/***/ })

},[186]);


// WEBPACK FOOTER //
// static/js/app.17d6053403586fb1cf4a.js